export default __webpack_public_path__ + "static/media/leche.dfe73e73.JPG";